module.exports = __webpack_public_path__ + "images/icons_v2/volume-off-filled-01a2078a.svg";